<svg
  class="h-full w-full animate-spin"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 20 20"
  fill="none"
>
  <path
    fill="#fff"
    fill-rule="evenodd"
    d="M9.99994 2.62511c-4.10075 0-7.37489 3.27414-7.37489 7.37489 0 4.1007 3.27414 7.3749 7.37489 7.3749 4.10076 0 7.37486-3.2742 7.37486-7.3749 0-4.10075-3.2741-7.37489-7.37486-7.37489ZM.166748 10c0-5.43072 4.402472-9.833191 9.833192-9.833191C15.4307.166809 19.8331 4.56928 19.8331 10c0 5.4307-4.4024 9.8332-9.83316 9.8332C4.56922 19.8332.166748 15.4307.166748 10Z"
    clip-rule="evenodd"
  />
  <path
    fill="#75C9EB"
    fill-rule="evenodd"
    d="M17.3749 10c0-4.07304-3.3019-7.37489-7.3749-7.37489V.166809c5.4307 0 9.8332 4.402471 9.8332 9.833191h-2.4583Z"
    clip-rule="evenodd"
  />
</svg>
